import { LocalizedValueModel } from '..';
import { AutomatedActionTypeEnum, EventExecutorTypeEnum } from '../enums';

export class DataEntityActionPresenterModel {
  id: string;
  /**
   * The action name
   */
  name: LocalizedValueModel;
  /**
   * Similar to data entity
   */
  normalizedName: string;
  /**
   * The action type
   */
  actionType: AutomatedActionTypeEnum;
  options: DataEntityActionOptions;

  executorType: EventExecutorTypeEnum;
  /**
   * Set the result for the action in the referenced field
   */
  resultField?: string; // 'normalized-name'
  /**
   * The list of options to override in the action by the end user.
   */
  overridableOptions: DataEntityActionOverridableOptions[];
}

export interface DataEntityActionOverridableOptions {
  /**
   * Path of the option inside the action options
   */
  optionPath: string;
}

export class DataEntityActionOptions {
  [key: string]: any;
}
